'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'fire';
var width = 448;
var height = 512;
var aliases = [128293];
var unicode = 'f06d';
var svgPathData = 'M227.2 119.4c-9.9-12.4-30-32.8-49.4-51.6l-1.8-1.7c-14.7 14.8-32.7 34.3-50.7 56.6c-20.7 25.6-40.5 54.1-55 83C55.8 234.8 48 261.6 48 284.5C48 386.3 125.6 464 224 464c97.2 0 176-77.8 176-179.5c0-41.7-25.6-90.4-58.3-133.7c-11.3-14.9-22.6-28.1-32.5-38.9c-1.9 1.8-3.4 3.3-4.6 4.6c-1.3 1.3-1.8 2-1.9 2.1c0 0 0 0 0 0l-37.3 48.7-38.3-47.9zM0 284.5C0 152 176 0 176 0s29.4 27 55.9 53.8c12.8 12.9 24.9 25.8 32.7 35.6c6.8-8.9 23.5-23.3 35.1-32.9c7.1-5.8 12.3-9.9 12.3-9.9s136 121.4 136 237.9C448 412.2 348.2 512 224 512C98.4 512 0 412.1 0 284.5zM225.7 416C162.6 416 112 375.4 112 306.8c0-33.6 21.1-63 63.2-114.8c5.6 7 87.1 110.6 87.1 110.6l50.6-58.8c4.2 5.6 7 11.2 9.8 16.8c25.3 46.2 14 105-28.1 134.4c-21.1 14-43.5 21-68.8 21z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;